import { getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Gets amounts of the year by a yearly distribution.
 */
export const getAgilePurchaseTradedSectors = factoryAuthService(({ sectorsIds, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compraAgil/compras/sector/${year}?sector=${sectorsIds.join(',')}`)
)
/**
 * Gets buyer's by sector and year
 */
export const getAgilePurchaseTradedBuyers = factoryAuthService(({ sectorsIds, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compraAgil/compras/comprador/${year}?sector=${sectorsIds.join(',')}`)
)
/**
 * Gets provider's by year and region
 */
export const getAgilePurchaseProviders = factoryAuthService(({ year, region }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compraAgil/compras/proveedor/${region}/${year}`)
)
/**
 * Gets top provider's by year and region
 */
export const getAgilePurchaseTradedTopProviders = factoryAuthService(({ year, region }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compraAgil/compras/proveedor/top/${region}/${year}`)
)
/**
 * Gets heading in level 1 by year and region
 */
export const getAgilePurchaseHeadingLvlOne = factoryAuthService(({ year, region }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compraAgil/compras/rubroN1/${region}/${year}`)
)
/**
 * Gets heading in level 2 by year, region and HeadingFatherId
 */
export const getAgilePurchaseHeadingLvlTwo = factoryAuthService(({ year, region, headingFatherId }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compraAgil/compras/rubroN2/${headingFatherId}/${region}/${year}`)
)
/**
 * Gets heading in level 3 by year, region and HeadingFatherId
 */
export const getAgilePurchaseHeadingLvlThree = factoryAuthService(({ year, region, headingFatherId }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compraAgil/compras/rubroN3/${headingFatherId}/${region}/${year}`)
)
/**
 * Gets heading in level 4 by year, region and HeadingFatherId
 */
export const getAgilePurchaseHeadingLvlFour = factoryAuthService(({ year, region, headingFatherId }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compraAgil/compras/rubroN4/${headingFatherId}/${region}/${year}`)
)

/**
 * Gets search heading
 */
export const getAgilePurchaseSearchProducts = factoryAuthService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compraAgil/rubro/productos`)
)

/**
 * Gets Institutions by level, heading, regin and year
 */
export const getAgilePurchaseInstitutions = factoryAuthService(({ level, heading, region, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compraAgil/compras/institucion/${level}/${heading}/${region}/${year}`)
)
